import { createContext } from "react";

const progressContext = createContext();

export default progressContext;